const OAuthClientConfig = {};
var currentFullBaseUrl = (window.location.protocol + '//' + window.location.host);

const authority = {
    prod: currentFullBaseUrl,
    local: 'https://idam-dev.metrosystems.net'
};

OAuthClientConfig.authority = authority[ENV_VAR || 'prod'];

OAuthClientConfig.openIdConfiguration = OAuthClientConfig.authority + "/.well-known/openid-configuration";
OAuthClientConfig.scopes = ['openid', 'profile'];
OAuthClientConfig.nonce = 'nonce';
OAuthClientConfig.grant_type = 'authorization_code';
OAuthClientConfig.client_id = {
    emp: 'IDAM_LOGIN_PREFS_EMP',
    cust: 'IDAM_LOGIN_PREFS_CUST',
    supp: 'IDAM_LOGIN_PREFS_SUPP',
    dev: 'IDAM_LOGIN_PREFS_DEV'
};
OAuthClientConfig.redirect_uri = currentFullBaseUrl + '/web/handleauth';
OAuthClientConfig.default_url = currentFullBaseUrl + '/';
OAuthClientConfig.relogin_url = currentFullBaseUrl + '/relogin';
OAuthClientConfig.user_type = 'EMP';
OAuthClientConfig.realm_id = 'IDAM_LPREALM';
OAuthClientConfig.response_type = 'code id_token';
OAuthClientConfig.locale_id = 'en-GB';
OAuthClientConfig.code_challenge_method = 'S256';
OAuthClientConfig.postLogoutRedirectUri = currentFullBaseUrl + '/web/loginpreferences';

module.exports = OAuthClientConfig;